import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="main-header">
      {/* Top Navigation Bar */}
      <div className="top-bar">
        <div className="top-bar-content">
          {/* Left section */}
          <div className="top-bar-left">
            <button className="global-menu-btn" onClick={toggleMenu}>
              <span className="menu-icon">
                <span></span>
                <span></span>
                <span></span>
              </span>
              <span className="menu-text">Menu</span>
            </button>
          </div>

          {/* Center logo */}
          <div className="top-bar-center">
            <a href="/" className="dc-logo">
              <img
                src="/croped-logo.png"
                alt="The Jaipur Hotels"
              />
            </a>
          </div>

          {/* Right section */}
          <div className="top-bar-right">
            <button className="contact-btn" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</button>
          </div>
        </div>
      </div>

      {/* Bottom Navigation Bar */}
      <div className={`bottom-bar ${isScrolled ? 'is-scrolled' : ''}`}>
        <div className="bottom-bar-content">
          {/* Hotel Name */}
          <div className="hotel-name">
            <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>THE JAIPUR HOTELS</a>
          </div>

          {/* Navigation Menu */}
          <nav className="main-nav">
            <ul className="nav-list">
              <li className="nav-item">
                <a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>HOME</a>
              </li>
              <li className="nav-item">
                <a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>ABOUT US</a>
              </li>
              <li className="nav-item">
                <a href="#rooms" onClick={(e) => { e.preventDefault(); scrollToSection('rooms'); }}>ROOMS</a>
              </li>
              <li className="nav-item">
                <a href="#gallery" onClick={(e) => { e.preventDefault(); scrollToSection('gallery'); }}>GALLERY</a>
              </li>
              <li className="nav-item">
                <a href="#dining" onClick={(e) => { e.preventDefault(); scrollToSection('dining'); }}>DINING</a>
              </li>
              <li className="nav-item">
                <a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>SERVICES</a>
              </li>
              <li className="nav-item">
                <a href="#attractions" onClick={(e) => { e.preventDefault(); scrollToSection('attractions'); }}>NEARBY ATTRACTIONS</a>
              </li>
              <li className="nav-item">
                <a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>CONTACT</a>
              </li>
            </ul>
          </nav>

          {/* Book Stay Button */}
          <div className="book-stay-wrapper">
            <button className="book-stay-btn" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>BOOK STAY</button>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar Menu */}
      <div className={`mobile-menu ${isMenuOpen ? 'active' : ''}`}>
        <div className="mobile-menu-overlay" onClick={toggleMenu}></div>
        <div className="mobile-menu-content">
          <button className="close-menu" onClick={toggleMenu}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M6 6L18 18M6 18L18 6" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
          <nav className="mobile-nav">
            <ul>
              <li><a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>HOME</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>ABOUT US</a></li>
              <li><a href="#rooms" onClick={(e) => { e.preventDefault(); scrollToSection('rooms'); }}>ROOMS</a></li>
              <li><a href="#gallery" onClick={(e) => { e.preventDefault(); scrollToSection('gallery'); }}>GALLERY</a></li>
              <li><a href="#dining" onClick={(e) => { e.preventDefault(); scrollToSection('dining'); }}>DINING</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>SERVICES</a></li>
              <li><a href="#attractions" onClick={(e) => { e.preventDefault(); scrollToSection('attractions'); }}>NEARBY ATTRACTIONS</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>CONTACT</a></li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
